// Mutations
// eslint-disable-next-line import/prefer-default-export
export const MUTATE_SNACKBAR = 'MUTATE_SNACKBAR';
